"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const schema_1 = require("../schema");
class AliasSchema extends schema_1.Schema {
    constructor(parameters) {
        super(parameters);
        this._sourceName = parameters.sourceName;
    }
    expected(utils) {
        return utils.schemas[this._sourceName].expected(utils);
    }
    validate(value, utils) {
        return utils.schemas[this._sourceName].validate(value, utils);
    }
    redirect(_value, _utils) {
        return this._sourceName;
    }
}
exports.AliasSchema = AliasSchema;
